import { render, staticRenderFns } from "./dataPushFailuresList.vue?vue&type=template&id=deb53ae6&scoped=true&"
import script from "./dataPushFailuresList.vue?vue&type=script&lang=js&"
export * from "./dataPushFailuresList.vue?vue&type=script&lang=js&"
import style0 from "./dataPushFailuresList.vue?vue&type=style&index=0&id=deb53ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb53ae6",
  null
  
)

export default component.exports